export default {
  roundtrip: {
    roundtripOptions: 'Rundweg Optionen'
  }
}
